/** @format */

import React from "react";

const CabBooking = () => {
  return (
    <section className="container">
      <h1 className="headline">Privacy Policy for Flyweis Cab Booking</h1>
      <p>Effective Date: 26/12/2024</p>
      <p>
        At Flyweis Cab Booking, we are committed to protecting your privacy.
        This Privacy Policy explains how we collect, use, and share your
        personal information when you use our cab booking and rental services
        (collectively referred to as "Services").
      </p>
      <h4>1. Information We Collect</h4>
      <p>
        We collect the following types of information when you use our Services:
      </p>
      <p>
        Personal Information: Name, email address, phone number, payment
        information, and any other details you provide when registering or
        booking a ride. <br />
        Location Data: We collect your device's location to provide real-time
        navigation and ride tracking. <br />
        Ride Data: Information about the rides you book, including the pickup
        and drop-off locations, ride duration, and payment details. <br />
        Device Information: Data such as your IP address, operating system,
        device type, and mobile carrier for troubleshooting and improving the
        app's performance. <br />
        Communication Data: Any messages you send through the app, including
        customer support inquiries.
      </p>
      <h4>2. How We Use Your Information</h4>

      <p>We use your information for the following purposes:</p>
      <p>
        To provide, maintain, and improve our Services, including booking and
        managing rides, calculating fares, and processing payments.
        <br />
        To communicate with you, including confirming bookings, sending
        receipts, and providing customer support. <br />
        To send marketing materials and promotional offers (you can opt-out of
        this at any time). <br />
        To personalize your experience and improve app functionality.
        <br />
        To comply with legal requirements or resolve disputes.
      </p>

      <h4>3. How We Share Your Information</h4>

      <p>We may share your personal information with:</p>

      <p>
        Third-party service providers: Such as payment processors, cloud storage
        providers, and analytics companies. <br />
        Drivers: For the purpose of booking and completing your ride, including
        sharing your location, destination, and contact details. <br />
        Legal authorities: If required to do so by law or in response to a legal
        request, such as subpoenas or court orders.
      </p>

      <h4>4. Data Security</h4>
      <p>
        We take reasonable precautions to protect your personal information from
        unauthorized access, use, or disclosure. This includes encryption,
        secure servers, and other industry-standard security measures. However,
        no method of transmission over the internet is 100% secure, so we cannot
        guarantee absolute security.
      </p>
      <h4>5. Your Choices</h4>
      <p>You have the following choices regarding your personal data:</p>
      <p>
        Opt-out of marketing communications: You can opt-out of receiving
        promotional emails or notifications at any time by updating your
        preferences in the app or through the unsubscribe link in emails. <br />
        Manage location permissions: You can control or disable location access
        through your device settings, but doing so may limit the functionality
        of the app. <br />
        Access, update, or delete your information: You can review, update, or
        request deletion of your personal data by contacting us at
        [info@flyweis.technology].
      </p>
      <h4>6. Retention of Data</h4>

      <p>
        We retain your personal data only for as long as necessary to fulfill
        the purposes outlined in this Privacy Policy, comply with legal
        obligations, resolve disputes, and enforce agreements.
      </p>
      <h4>7. Third-Party Links</h4>
      <p>
        Our app may contain links to third-party websites or services that are
        not operated by us. We are not responsible for the privacy practices of
        those third parties, and we encourage you to read their privacy
        policies.
      </p>
      <h4>8. Changes to This Privacy Policy</h4>
      <p>
        We may update this Privacy Policy from time to time. Any changes will be
        posted in the app, and we will notify you of material changes. Please
        review the policy periodically for updates.
      </p>
      <h4>9. Contact Us</h4>
      <p>
        For any questions or concerns regarding this Privacy Policy, please
        contact us at info@flyweis.technology. <br />
        By using the App, you acknowledge that you have read, understood, and
        agreed to this Privacy Policy.
      </p>
    </section>
  );
};

export default CabBooking;
